import { ToastStateHandler } from '../../api';
import { store } from '../../store';
import { setHasUnreadNotifications } from '../../store/slices/notification-center.slice';
import { GlobalApi } from '../../util/Global';

export class UserHandler {
    constructor(private readonly toastHandler: ToastStateHandler, private readonly languageData: any, private readonly globalApi: GlobalApi) {}

    public userRoleChanged(): void {
        this.toastHandler.push('warn', this.languageData.roleChanged.notificationTitle, this.languageData.roleChanged.notificationContent);
        setTimeout(() => {
            this.globalApi.href('/role-changed');
        }, 7000);
    }

    public notificationCreation(): void {
        store.dispatch(setHasUnreadNotifications(true));
    }
}
